export function getUserData (state) {
  return state.userData
}

export function getToken (state) {
  return state.token
}

export function getSavedVacancies (state) {
  return state.savedVacancies
}

export function getFolders (state) {
  return state.folders
}

export function getUserRecruited (state) {
  return state.recruited
}

export function getUserRecruitedCategories (state) {
  return state.recruitedCategories
}

export function getUserRecruitedCompanies (state) {
  return state.recruitedCompanies
}



// WEBPACK FOOTER //
// ./src/vuex/users/getters.js